import * as React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Icon, Button} from 'mkui-fd';
import Basic from '../_layout';
import generator from '../_layout/util';

class Layout extends React.PureComponent {

  static defaultProps = {
    prefixCls: 'mkui-layout-inner-modal',
    okText: '确定',
    cancelText: '取消',
  };

  static propTypes = {
    prefixCls: PropTypes.string,
    title: PropTypes.node,
    afterClose: PropTypes.func,
    onOk: PropTypes.func,
    onCancel: PropTypes.func,
    okText: PropTypes.string,
    cancelText: PropTypes.string,
  };


  handleCancel = (e) => {
    const onCancel = this.props.onCancel;
    if (onCancel) {
      onCancel(e);
    }
  }

  handleOk = (e) => {
    const onOk = this.props.onOk;
    if (onOk) {
      onOk(e);
    }
  }

  renderFooter = () => {
    const {prefixCls, okText, cancelText, confirmLoading} = this.props;
    return (
      <div className={`${prefixCls}-footer`}>
        <Button
          size="large"
          type="secondary"
          onClick={this.handleCancel}
        >
          {cancelText}
        </Button>
        <Button
          size="large"
          type="primary"
          loading={confirmLoading}
          onClick={this.handleOk}
          className="mkui-btn-primary"
        >
          {okText}
        </Button>
      </div>
    );
  }

  renderHeader = () => {
    const {title, prefixCls, afterClose} = this.props;
    return (
      <div className={`${prefixCls}-header`}>
        <span className={`${prefixCls}-header-title`}>{title}</span>
        <button className={`${prefixCls}-header-close`}><span className={`${prefixCls}-header-close-x`}><Icon
          className={`${prefixCls}-header-close-icon`}
          onClick={afterClose}
          type={'close'}/></span></button>
      </div>
    );
  }

  render() {
    const {prefixCls, className, children} = this.props;
    const divCls = classNames(className, prefixCls);
    return (<div className={divCls}>
      {this.renderHeader()}
      <div className={`${prefixCls}-body`}>{children}</div>
      {this.renderFooter()}
    </div>);
  }
}

const Toolbar = generator({
  prefixCls: 'mkui-layout-inner-modal-body-toolbar',
})(Basic);
const Content = generator({
  prefixCls: 'mkui-layout-inner-modal-body-content',
})(Basic);

Layout.Toolbar = Toolbar;
Layout.Content = Content;
export default Layout;
